<template>
  <div>
    <BlocoFiltroPesquisa
      :nome-do-form="nomeDoForm"
      :ordenar-por="['nome', 'perfil', 'email']"
      :ordenar-nomes="['Nome', 'Perfil', 'E-mail']"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <CampoNome
              id="nome"
              :valor="filtro.nome"
              @atualizar="filtro.nome = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <CampoEmail
              :valor="filtro.email"
              @atualizar="filtro.email = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
            <SelecionarPerfil
              :valor="filtro.perfil"
              @atualizar="filtro.perfil = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela><UsuarioTabela :usuarios="usuarios" /></template>
      <template #fichas>
        <div
          v-for="usuario in usuarios"
          :key="usuario._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <UsuarioFicha :usuario="usuario" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>
<script>
import AwesomeMask from 'awesome-mask'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoEmail from '@/componentes/formulario/CampoEmail'
import CampoNome from '@/componentes/formulario/CampoNome'
import SelecionarPerfil from '@/componentes/formulario/SelecionarPerfil'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import PERFIL from '@/constantes/controle_acesso/PERFIL'
import UsuarioServico from '@/servicos/UsuarioServico'

import UsuarioFicha from './UsuarioFicha'
import UsuarioTabela from './UsuarioTabela'

export default {
  components: {
    UsuarioFicha,
    UsuarioTabela,
    BlocoFiltroPesquisa,
    CampoNome,
    CampoEmail,
    SelecionarPerfil,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  directives: { mask: AwesomeMask },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const usuarios = ref([])
    const perfis = ref(PERFIL.valores)
    const servico = new UsuarioServico()
    const nomeResultado = 'usuarios'
    const nomeDoForm = 'UsuarioForm'
    const filtro = ref({
      nome: '',
      ativo: '',
      perfil: '',
      email: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: usuarios,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(25)
    return {
      usuarios,
      perfis,
      servico,
      filtro,
      ...pesquisa,
    }
  },
}
</script>
